import { render, staticRenderFns } from "./OTC.vue?vue&type=template&id=358a78f0"
import script from "./OTC.vue?vue&type=script&lang=js"
export * from "./OTC.vue?vue&type=script&lang=js"
import style0 from "./OTC.vue?vue&type=style&index=0&id=358a78f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports